import Vue from 'vue'

import pageBase from './base/base.vue'
import pageCate from './category/category.vue'
import pageCart from './cart/cart.vue'
import pageUser from './user/user.vue'
import pageLive from '@/views/onlinePages/live/list.vue'

Vue.component('page-base', pageBase)
Vue.component('page-cate', pageCate)
Vue.component('page-cart', pageCart)
Vue.component('page-user', pageUser)
Vue.component('page-live', pageLive)
